import React, { useContext } from 'react';

export const FeatureTogglesContext = React.createContext<FeatureTogglesContextValue>(undefined);

interface FeatureTogglesProviderProps {
  value: FeatureTogglesContextValue,
  children: React.ReactNode
}

export interface FeatureTogglesContextValue {
  hideEnrollmentPage: boolean,
  hideUserManagement: boolean,
  showAccessPointsPage: boolean,
  showDeviceFinderSettings: boolean,
  showDeviceWifiTab: boolean,
  showAnomalyDetectionBeta: boolean,
  showProcessesTabs: boolean
}

export const FeatureTogglesProvider = ({ children, value }: FeatureTogglesProviderProps) => {
  return (
    <FeatureTogglesContext.Provider value={value}>
      {children}
    </FeatureTogglesContext.Provider>
  );
};

export function useFeatureTogglesContext() {
  const context = useContext(FeatureTogglesContext);
  if (context === undefined) {
    throw new Error('useFeatureTogglesContext must be used within a FeatureTogglesProvider');
  }
  return context;
}
